<template>
	<div id="app">
		<main id="main_contents">
			<div class="container">
				<RouterView />
        <vue-loading :active.sync="loadingStatus" :can-cancel="false" :is-full-page="true" type="spin"></vue-loading>
			</div>
		</main>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import { USER_LOGIN, GROUP_EXPIRED } from '@/store/error'
  import VueLoading from 'vue-loading-overlay'

	export default {
    name: 'App',
    computed: {
      ...mapState({
        statusCode: state => state.error.statusCode,
        errorMessage: state => state.error.message,
        loadingStatus: state => state.loading.loadingStatus,
      })
    },
    watch: {
      statusCode: {
        handler: function (value) {
          if (!value) {
            return
          }
          if (10000000 < this.statusCode) {
            if (USER_LOGIN === this.statusCode || GROUP_EXPIRED === this.statusCode) {
              navigator.notification.alert(
                  this.errorMessage,
                  () => {
                    this.$store.dispatch('authorize/logoutApi')
                    NativeStorage.remove("profile", () => { this.$router.push('/').catch(error => {}) }, null);
                  },
                  'エラーコード : ' + this.statusCode
              )
              return
            }
            navigator.notification.alert(
                this.errorMessage,
                null,
                'エラーコード : ' + this.statusCode
            )
            this.$store.commit('error/setStatusCode', null)
            this.$store.commit('error/setMessage', null)
            return
          }
          navigator.notification.alert(
              "予期せぬエラーが発生しました。",
              () => {
                this.$router.push('/')
              },
              'エラーコード : ' + this.statusCode
          );
        },
      },
      $route() {
        this.$store.commit('error/setStatusCode', null)
        this.$store.commit('error/setMessage', null)
      }
    },
    components: {
      VueLoading,
    }
  }
</script>